module.exports = __webpack_public_path__ + "img/logo.a37a52ab.png";